import React, { useContext } from 'react';
import './services.scss';
import { Link, useParams } from "react-router-dom";
import { AppContext } from '../../services/translationContext';
import { PageHero } from '../../components/page-hero/page-hero';
import { ServiceCard } from '../../components/cards/service-card';
import SeoHelmet from '../../components/SeoHelmet';

export const Services = () => {
    const { lang } = useParams();
    const { services: {TranslationsService} } = useContext(AppContext);
    const servicesList = TranslationsService.labels('services');

    const pageTitle = `${TranslationsService.labels(`menu.services.label`)} | ${TranslationsService.getMainInfoCompany('name')}`;
    const pageDescription = TranslationsService.labels('hero_sections.services.text');
    const pageUrl = `https://www.sydea.com/${lang}/services`;

    const collectionSchema = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: TranslationsService.labels(`menu.services.label`),
      description: pageDescription,
      url: pageUrl
    };

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `https://www.sydea.com/${lang}` },
        { "@type": "ListItem", position: 2, name: TranslationsService.labels(`menu.services.label`), item: pageUrl }
      ]
    };

  return (
    <div className="section-home">
      <SeoHelmet
        title={pageTitle}
        description={pageDescription}
        image={TranslationsService.labels('hero_sections.services.img_path')}
        schema={[collectionSchema, breadcrumbSchema]}
      />
      <PageHero
        bgImage={TranslationsService.labels('hero_sections.services.img_path')}
        breadcrumb={[]}
        title={TranslationsService.labels(`menu.services.label`)}
        subtitle={TranslationsService.labels(`hero_sections.services.text`)}
        hideBreadcrumb={true}
      />
        <div className='container'>
            {
                Object.keys(servicesList).map((area,indice) => {
                    return (
                    <div key={indice}>
                        <div className='my-2 title-service-sticky'>
                            <Link to={`/${lang}/services/${area}`} className='text-deco-none d-flex gap-3 align-items-center title-area' style={{width:'max-content'}}>
                                <h2 className='syd-title white m-0 fw-bold transition-03s-eio' style={{color:'#fece2f', fontSize:'4rem', zIndex: 9999}}>{servicesList[area].title}</h2>
                            </Link>
                        </div>
                        <div>
                            {
                                TranslationsService.labels('services')[area].items ?
                                (
                                Object.keys(TranslationsService.labels('services')[area].items).map((_sub, i) => (
                                    <div key={i}>
                                        <Link to={`/${lang}/services/${area}/${_sub}`} className='text-deco-none'>
                                            <h3 className='dark-mode-text m-0 fw-bold transition-03s-eio fs-3 pb-3'>{TranslationsService.labels('services')[area].items[_sub].title}</h3>
                                        </Link>
                                        <div className='container px-md-5'>
                                            <div className='row'>
                                            {
                                                TranslationsService.labels('services')[area].items[_sub] ?
                                                (
                                                    Object.entries(TranslationsService.labels('services')[area].items[_sub])
                                                    .filter(([key, val]) =>
                                                      typeof val === 'object' &&
                                                      val.title
                                                    )
                                                    .map(([subItemKey, subItemValue], j) => (
                                                      <ServiceCard 
                                                        key={j}
                                                        colMD={4}
                                                        colSM={12}
                                                        bgImage={subItemValue.image}
                                                        title={subItemValue.title}
                                                        link={`/${lang}/services/${area}/${_sub}/${subItemKey}`}
                                                      />
                                                    ))
                                                  
                                                ) : null
                                            }
                                            </div>
                                        </div>
                                    </div>
                                ))
                                )
                                :
                                (
                                <div className='container px-md-5'>
                                    <div className='row'>
                                    {
                                        Object.entries(servicesList[area])
                                        .filter(([key, val]) => typeof val === 'object' && val.title)
                                        .map(([subbu, val], i) => (
                                          <ServiceCard 
                                            key={i}
                                            colMD={4}
                                            colSM={12}
                                            bgImage={val.image}
                                            title={val.title}
                                            link={`/${lang}/services/${area}/${subbu}`}
                                          />
                                        ))
                                    }
                                    </div>
                                </div>

                               
                                )
                            }
                        </div>
                    </div>
                    );
                })
            }
        </div>
    </div>
  );
};